import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/production-exceptions", { params });
};

const getAllDetail = params => {
  return restApiMP.get("/api/production-exceptions-detail", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/production-exceptions-detail/csv", { params });
}

const productionExceptionsService = {
  getAll,
  getAllDetail,
  getAllForCSV
};

export default productionExceptionsService;